export const getHomeHeroHeader = (uid: string, data: any, offerData: any) => {
  switch (uid) {
    case 'mastercard-easy-savings':
      return offerData.hero_heading
      break

    default:
      return data.hero_heading
      break
  }
}

export const getHomeHeroImage = (uid: string, data: any, offerData: any) => {
  switch (uid) {
    case 'mastercard-easy-savings':
      return offerData.hero_image
      break

    default:
      return data.hero_image
      break
  }
}
